import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "style", "children", "rootNodeRef"];

var _class, _class2, _temp;

import React from 'react';
import { isFunction, isRefableElement } from "../../../lib/utils";
import { cx } from "../../../lib/theming/Emotion";
import { getRootNode, isInstanceWithRootNode, rootNode } from "../../../lib/rootNode";
import { callChildRef } from "../../../lib/callChildRef/callChildRef";
import { extractCommonProps } from "../extractCommonProps";
import { getCommonVisualStateDataAttributes } from "../getCommonVisualStateDataAttributes";
export var CommonWrapper = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CommonWrapper, _React$Component);

  function CommonWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.rootNodeSubscription = null;

    _this.ref = function (instance) {
      var _this$rootNodeSubscri, _this$child;

      _this.setRootNode(instance);

      _this.props.rootNodeRef == null ? void 0 : _this.props.rootNodeRef(getRootNode(instance)); // refs are called when instances change,
      // so we have to renew or remove old subscription

      (_this$rootNodeSubscri = _this.rootNodeSubscription) == null ? void 0 : _this$rootNodeSubscri.remove();
      _this.rootNodeSubscription = null;

      if (instance && isInstanceWithRootNode(instance)) {
        _this.rootNodeSubscription = instance.addRootNodeChangeListener == null ? void 0 : instance.addRootNodeChangeListener(function (node) {
          _this.setRootNode(node);

          _this.props.rootNodeRef == null ? void 0 : _this.props.rootNodeRef(node);
        });
      }

      var originalRef = (_this$child = _this.child) == null ? void 0 : _this$child.ref;
      originalRef && callChildRef(originalRef, instance);
    };

    return _this;
  }

  var _proto = CommonWrapper.prototype;

  _proto.render = function render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _extractCommonProps = extractCommonProps(this.props),
        _extractCommonProps$ = _extractCommonProps[0],
        className = _extractCommonProps$.className,
        style = _extractCommonProps$.style,
        children = _extractCommonProps$.children,
        rootNodeRef = _extractCommonProps$.rootNodeRef,
        dataProps = _objectWithoutPropertiesLoose(_extractCommonProps$, _excluded),
        rest = _extends({}, _extractCommonProps[1]);

    this.child = isFunction(children) ? children(rest) : children;
    return /*#__PURE__*/React.isValidElement(this.child) ? /*#__PURE__*/React.cloneElement(this.child, _extends({
      ref: isRefableElement(this.child) ? this.ref : null,
      className: cx(this.child.props.className, className),
      style: _extends({}, this.child.props.style, style)
    }, getCommonVisualStateDataAttributes(rest), dataProps)) : this.child;
  };

  return CommonWrapper;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'CommonWrapper', _class2.displayName = 'CommonWrapper', _temp)) || _class;